<app-navbar></app-navbar>
<div
  class="container"
  style="padding-top: 50px; padding-bottom: 50px; text-align: justify"
>
  <div
    class="card"
    style="
      padding: 20px; //background-image: url('assets/img/school/bg.png');
      background-color: #005a63;
      background-size: 100px;
      background-attachment: fixed;
    "
  >
    <h2 style='text-align: center; margin-bottom: 10px; color: white;'>Organisational Structure</h2>
    <div>
      <img
        class="img-fluid"
        style="
          height: 100%;
          width: 100%;
          object-fit: cover;
          border-radius: 10px;
        "
        src="assets/img/school/orgStructure.jpg"
      />
    </div>
    <!-- <div class="card-body">
      <h2>Design of Five-Storied Building of PROYASH CHATTOGRAM</h2>
      <h4>Proyash is a specialized institute which provides services for holistic development of the children with
        special
        educational needs through multidimensional programs. The institute also serves as training and research center
        for the
        development of special education for teachers and therapists.</h4> <br>
      <br>
      <h4>Design Brief</h4>
      <p>Located in Chattogram Cantonment <br>
        Foundation built for eight storied structure <br>
        Number of floors is five and one basement <br>
        Land area is 1.31 acre <br>
        Total built area is 1,01,210 sft <br>
        Parking for 32 cars (Basement: 20, Surface: 12) and 4 buses

      </p>
    </div> -->
  </div>
</div>
